import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import type { RedoListItem } from "@redotech/arbiter/list/redo-list";
import { RedoListDropdown } from "@redotech/arbiter/list/redo-list-dropdown";
import PlusIcon from "@redotech/redo-icons/plus.svg";
import { memo, useState } from "react";
import type { ReturnsCenterRow } from "./use-returns-center-rows";
interface AddReturnsCenterExceptionProps {
  buttonText?: string;
  centers: readonly ReturnsCenterRow[];
  disabled: boolean;
  onAdd: (returnsCenterId: string) => void;
}

/** "Add exception", listing the centers that follow the default. */
export const AddReturnsCenterException = memo(
  function AddReturnsCenterException({
    buttonText = "Add exception",
    centers,
    disabled,
    onAdd,
  }: AddReturnsCenterExceptionProps) {
    const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);
    const items: RedoListItem<string>[] = centers.map((center) => ({
      type: "text",
      id: center.id,
      value: center.id,
      text: center.name,
      supportingText: center.location,
    }));
    return (
      <Flex>
        <RedoButton
          disabled={disabled}
          hierarchy="link"
          IconLeading={PlusIcon}
          onClick={() => setOpen(!open)}
          ref={setAnchor}
          size="sm"
          text={buttonText}
        />
        <RedoListDropdown
          dropdownAnchor={anchor}
          dropdownOpen={open}
          items={items}
          itemSelected={({ item }) => {
            onAdd(item.value);
            setOpen(false);
          }}
          setDropdownOpen={setOpen}
          size="xs"
        />
      </Flex>
    );
  },
);
